import api from './api';

/**
 * Servicio para gestión de usuarios PostgreSQL
 * 
 * Conecta el frontend con las APIs de usuarios deportivos
 * Maneja usuarios: administradores, entrenadores, futbolistas
 */

const postgresUserService = {
  /**
   * Obtener todos los usuarios PostgreSQL
   * @returns {Promise<Object>} Lista de usuarios
   */
  async getUsuarios() {
    try {
      const response = await api.get('/postgres/usuarios');
      console.log('🔍 postgresUserService.getUsuarios response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios PostgreSQL:', error);
      throw error;
    }
  },

  /**
   * Obtener usuario PostgreSQL por ID
   * @param {number} id - ID del usuario
   * @returns {Promise<Object>} Usuario
   */
  async getUsuario(id) {
    try {
      const response = await api.get(`/postgres/usuarios/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuario PostgreSQL:', error);
      throw error;
    }
  },

  /**
   * Crear nuevo usuario PostgreSQL
   * @param {Object} userData - Datos del usuario
   * @returns {Promise<Object>} Usuario creado
   */
  async createUsuario(userData) {
    try {
      const response = await api.post('/postgres/usuarios', userData);
      return response.data;
    } catch (error) {
      console.error('Error al crear usuario PostgreSQL:', error);
      throw error;
    }
  },

  /**
   * Actualizar usuario PostgreSQL
   * @param {number} id - ID del usuario
   * @param {Object} userData - Datos actualizados
   * @returns {Promise<Object>} Usuario actualizado
   */
  async updateUsuario(id, userData) {
    try {
      const response = await api.put(`/postgres/usuarios/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar usuario PostgreSQL:', error);
      throw error;
    }
  },

  /**
   * Eliminar usuario PostgreSQL
   * @param {number} id - ID del usuario
   * @returns {Promise<Object>} Confirmación
   */
  async deleteUsuario(id) {
    try {
      const response = await api.delete(`/postgres/usuarios/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar usuario PostgreSQL:', error);
      throw error;
    }
  },

  /**
   * Obtener roles disponibles
   * @returns {Promise<Object>} Lista de roles
   */
  async getRoles() {
    try {
      const response = await api.get('/postgres/usuarios/roles');
      console.log('🔍 postgresUserService.getRoles response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener roles:', error);
      throw error;
    }
  }
};

export default postgresUserService;
